import {useDebugValue} from 'react';

import {useOptions} from './';

const defaultOptions = {
    site: 'homeaway_us',
    baseUrl: 'https://www.homeaway.com',
    appPrefix: '/',
    locale: 'en_US'
};

function useSystemOptions(props) {
    const {
        systemOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useSystemOptions};
